<app-master-detail class="yf-master-detail" icon="cash-outline"
  [title]="masterOrDetail!=='master' ? ('MENU.PAYMENT_METHOD' | translate) : ''"
  titleMaster="{{'MENU.PAYMENT_METHOD' | translate}}" [titleDetail]="(currentStepDetail$ | async)?.title"
  [(show)]="masterOrDetail" filter="" (compactModeChange)="compactModeChange($event)" [forceCompact]="false">

  <div class="master">
    @if(threeDsUrl){
    <div class="tds-slot" [ngClass]="!compactMode ? 'detail-item' : 'detail-item-no-border'">
      <yf-cdc-3ds [url]="threeDsUrl" (frameLoad)="on3dsFrameLoad()" (cancelled)="on3dsClosed()"
        (openInBrowser)="on3dsOpenInBrowser()"></yf-cdc-3ds>
    </div>
    }
    @else if(waiting$ | async){
    <div [ngClass]="!compactMode ? 'detail-item' : 'detail-item-no-border'">
      <yf-cdc-waiting [phase]="waitingPhase$ | async"></yf-cdc-waiting>
    </div>
    }
    @else {
    <div class="m-6" *ngFor="let step of this.stepItems$|async; let index = index;"
      [ngClass]="{ selected: (currentStepDetail$ | async)?.id===step.id }">
      <ion-item button detail="true" [disabled]="!step.previuosStepsAccepted" (click)="showStepItem(step)">
        <ion-icon [name]="step.icon? step.icon : 'document-outline'" class="item-icon" slot="start"> </ion-icon>
        <ion-label>
          <h3 class="fw-600">{{ step.title }}</h3>
        </ion-label>
      </ion-item>
    </div>
    }
  </div>

  @if(currentStepDetail$ | async; as currentStep){
  <div class="pl-6 detail">
    @if(currentStep.stepFromCms){
    <div class="yf-container">
      <div>
        <div *ngFor="let section of currentStep.sections">
          <div class="mt-4 section-subtitle" *ngIf="section.subtitle">{{ currentStep.subtitle }}</div>
          <div class="mt-10 section-html" *ngIf="section.html" [innerHTML]="section.html"></div>
        </div>
      </div>
    </div>
    <ion-footer class="ion-no-border yf-footer">
      <ion-item class="pl-18 pb-18" *ngIf="currentStep.mustBeAccetped" (click)="toggleAcceptStepItem()">
        <ion-checkbox #ionCheckBox [checked]="currentStep.accepted" [disabled]="currentStep.accepted"></ion-checkbox>
        <ion-label>{{ "CDC_AUTHENTICATION.BUTTONS.ACCEPT_TERMS" | translate }}</ion-label>
      </ion-item>
      <ion-button
        [disabled]="currentStep.mustBeAccetped && (currentStepDetailAccepted$ | async)!==true && (loadingNextStep$|async)===false"
        class="btn-yf" color="secondary" expand="block" (click)="showNextStepItem(currentStep)">{{ "BUTTONS.NEXT" |
        translate }}
        <ion-icon slot="end" src="assets/app-icons/arrow_forward.svg"></ion-icon>
      </ion-button>
    </ion-footer>
    }
    @else{
    <div *ngIf="currentStep.type==='CREDIT_CARD'" [ngClass]="!compactMode ? 'detail-item' : 'detail-item-no-border'">
      @if (paymentAuth$ | async; as paymentAuth) {
      <div class="recap-card-container">
        <div class="recap-scroll">
          <yf-card-preview [number]="'••••••••••••' + (paymentAuth.cdcLast4 || paymentAuth.token || '')"
            [brand]="paymentAuth.cdcType" [owner]="user ? user.name + ' ' + user.surname : ''"
            [expiryMonth]="paymentAuth.cdcExpiryMonth" [expiryYear]="paymentAuth.cdcExpiryYear"></yf-card-preview>

          <div class="info-block">
            <ion-icon name="shield-checkmark-outline" color="success"></ion-icon>
            <ion-text>
              {{ ("CDC_AUTHENTICATION.AUTHENTICATION_MESSAGE" | translate:{value: paymentAuth.authorizedAt |
              date:'dd/MM/yyyy', value2: (paymentAuth.amount || 50) | number:'1.1-1' }) }}
            </ion-text>
          </div>

          <div class="info-block">
            <ion-icon name="information-circle-outline" color="primary"></ion-icon>
            <ion-text>
              {{ "CDC_AUTHENTICATION.REVOKE_MESSAGE" | translate}}
            </ion-text>
          </div>

          <div class="info-block">
            <ion-icon name="cash-outline" color="primary"></ion-icon>
            <ion-text>
              {{"CDC_AUTHENTICATION.NEXT_AUTHORIZATION_MESSAGE" | translate}}
            </ion-text>
          </div>

        </div>
        <div class="ion-padding-horizontal" class="footer">
          @if($sessionInProgress()){
          <div class="revoke-banner">
            <ion-card>
              <ion-card-content>
                {{ "CDC_AUTHENTICATION.CANT_REVOKE_AUTHORIZATION" | translate}}
              </ion-card-content>
            </ion-card>
          </div>
          }
          @else {
          <ion-button expand="block" color="danger" [disabled]="$sessionInProgress()" (click)="cdcRevocation()">{{
            "CDC_AUTHENTICATION.BUTTONS.REVOKE_AUTORIZATION" | translate }}</ion-button>
          }
        </div>
      </div>
      }

      @else{
      <div class="credit-card-form-container">
        @if(googlePayRegistrationVisible()){
        <div class="hosted-registration">
          <ion-button expand="block" color="dark" class="btn-yf" (click)="registerWithGooglePay()">
            <ion-icon slot="start" name="logo-google"></ion-icon>
            {{ "CDC_AUTHENTICATION.HOSTED_REGISTRATION.BUTTON" | translate }}
          </ion-button>
          <div class="hosted-registration-divider">{{ "CDC_AUTHENTICATION.HOSTED_REGISTRATION.OR_MANUAL" | translate }}
          </div>
        </div>
        }
        <ion-text>{{ "CDC_AUTHENTICATION.CREDIT_CARD" | translate }}</ion-text>
        <yfl-credit-card-form (cdcSubmitted)="cdcSubmitted($event)"></yfl-credit-card-form>
      </div>
      }

    </div>
    }
  </div>
  }
</app-master-detail>